"use client";

import { Link } from "@opensea/next-ui-kit";
import { CenterAligned, FlexColumn, Modal, ModalBody, ModalFooter, ModalFooterButton, TextBody, TextHeading } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useStore } from "zustand";
import { RiveChest } from "@/components/rewards/Rewards/Rive/RiveChest";
import { withSuspense } from "@/components/suspense/WithSuspense";
import { useOpenableTreasureChests } from "@/hooks/api/use-openable-treasure-chests";
import { useIsTreasureChestOpenable } from "@/hooks/use-flags";
import { TreasureChestAlertModalStore } from "./treasure-chest-alert-modal-store";
export const TreasureChestAlertModal = withSuspense(function TreasureChestAlertModal() {
  const t = useTranslations("TreasureChestOpenModal");
  const {
    isDismissed,
    dismiss
  } = useStore(TreasureChestAlertModalStore);
  const {
    openableTreasureChest,
    hasRewards
  } = useOpenableTreasureChests();
  const chestId = openableTreasureChest?.id;
  const currentLevel = openableTreasureChest?.userProgress?.currentLevel ?? 0;
  const isOpenable = useIsTreasureChestOpenable(openableTreasureChest?.isOpenable ?? false);
  const shouldShow = openableTreasureChest && isOpenable && hasRewards && !isDismissed(chestId ?? "");
  return <Modal content={<>
            <ModalBody>
              <FlexColumn className="gap-6">
                <CenterAligned className="gap-4">
                  <div className="flex h-[360px] w-[360px] items-center justify-center">
                    <RiveChest height="100%" level={currentLevel} stateMachines="CHEST" width="100%" />
                  </div>
                  <CenterAligned className="gap-2">
                    <TextHeading className="text-center" size="md">
                      {t("title")}
                    </TextHeading>
                    <TextBody className="text-center" color="text-secondary" size="sm">
                      {t("description")}
                    </TextBody>
                  </CenterAligned>
                </CenterAligned>
              </FlexColumn>
            </ModalBody>
            <ModalFooter className="flex-shrink-0 bg-bg-primary">
              <Link className="w-full" href="/rewards" variant="unstyled">
                <ModalFooterButton className="w-full" onClick={() => chestId && dismiss(chestId)} variant="primary">
                  {t("cta")}
                </ModalFooterButton>
              </Link>
            </ModalFooter>
          </>} onOpenChange={setOpen => {
    if (!setOpen && chestId) {
      dismiss(chestId);
    }
  }} open={shouldShow} size="md" withCloseIcon />;
});